// Tipos de usuario: el administrador puede todo lo del publicador. El servidor valida lo mismo en cada pedido.
export const ROLES = [
    { id: 'publisher', label: 'Publicador', can: 'Usa Republicación, Updates, Prerrequisitos (sólo se ven) y Clientes. En Auditoría ve sólo los registros de updates.' },
    { id: 'admin', label: 'Administrador', can: 'Todo lo del Publicador; además la pantalla de Administración y la auditoría completa.' },
];
export const DEFAULT_ROLE = 'publisher';

export const roleInfo = (role) => ROLES.find(r => r.id === role);
export const roleLabel = (role) => roleInfo(role)?.label || role;
export const isAdmin = (user) => user?.role === 'admin';
